import z from "zod";
import { projectsId, projectsInitializer } from "../../db_gen";
import { LOCALES } from "../../enums";
import { zodName, zodSlug } from "../../utils";

const createUpdateProjectSchema = z.object({
  name: zodName(),
  description: projectsInitializer.shape.description,
  defaultLocales: z.enum(LOCALES).array().min(1, "At least one locale is required"),
  color: projectsInitializer.shape.color.min(1, "Color is required"),
});

export type ProjectCreateUpdateSchema = z.infer<typeof createUpdateProjectSchema>;

export default {
  create: createUpdateProjectSchema,
  update: z.object({
    projectId: projectsId,
    data: createUpdateProjectSchema,
  }),
  delete: z.object({
    projectId: projectsId,
  }),
  getBySlug: z.object({
    projectSlug: zodSlug(),
  }),
};
